import { formatTime } from "jest-util";
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { dateFilterFn, dateFilterProps, formatTimestamp, getDate } from "@/lib/common-utils";
import { BoardingTable } from "@/shared/api";

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleString();
};

export const useBoardingTablesColumns = () => {
  const { t } = useTranslation();

  return useMemo<MRT_ColumnDef<BoardingTable>[]>(
    () => [
      {
        header: t("boardingTables.room"),
        id: "room",
        accessorFn: (row) => row.room,
      },
      {
        header: t("boardingTables.tid"),
        id: "tid",
        accessorFn: (row) => row.tid,
      },
      {
        header: t("boardingTables.gameType"),
        id: "gameType",
        accessorFn: (row) => row.game_type,
      },
      {
        header: t("boardingTables.gameGroup"),
        id: "gameGroup",
        accessorFn: (row) => row.game_group,
      },
      {
        header: t("boardingTables.aid"),
        id: "aid",
        accessorFn: (row) => row.aid,
      },
      {
        header: t("boardingTables.cid"),
        id: "cid",
        accessorFn: (row) => row.cid,
      },
      {
        header: t("boardingTables.limit"),
        id: "limit",
        accessorFn: (row) => row.limit,
      },
      {
        header: t("boardingTables.players"),
        id: "players",
        accessorFn: (row) => row.players?.length ?? 0,
      },
      {
        header: t("boardingTables.lastBoardingTimestamp"),
        id: "lastBoardingTimestamp",
        accessorFn: (row) => formatTimestamp(row.last_boarding_timestamp) ?? "-",
        filterVariant: "datetime-range",
        muiFilterDateTimePickerProps: dateFilterProps,
        filterFn: dateFilterFn,
      },
      {
        header: t("boardingTables.lastExitTime"),
        id: "lastExitTime",
        accessorFn: (row) => formatTimestamp(row.last_exit_time) ?? "-",
        filterVariant: "datetime-range",
        muiFilterDateTimePickerProps: dateFilterProps,
        filterFn: dateFilterFn,
      },
      {
        header: t("boardingTables.minHandsAtProfit"),
        id: "minHandsAtProfit",
        accessorFn: (row) => row.min_hands_at_profit,
      },
      {
        header: t("boardingTables.minHandsAfterAllin"),
        id: "minHandsAfterAllin",
        accessorFn: (row) => row.min_hands_after_allin,
      },
      {
        header: t("boardingTables.tableLeftTimeLimit"),
        id: "tableLeftTimeLimit",
        accessorFn: (row) => row.table_left_time_limit,
      },
      {
        header: t("boardingTables.boardingMode"),
        id: "boardingMode",
        accessorFn: (row) => row.boarding_mode,
      },
    ],
    [t]
  );
};
